import styled from 'styled-components';
import { FormComponent } from '../../../form';

export const BillFormContainer = styled(FormComponent)`
    input[readonly] {
        opacity: 0.5;
        pointer-events: none;
        cursor: not-allowed;
        background: ${props => props.theme.whiteSmoke};
    }
`;



// WEBPACK FOOTER //
// ./src/components/pages/ebon/bill/DownloadBillFormComponentStyle.js